module.exports = __webpack_public_path__ + "img/pdf.d50fb467.png";